import { render, staticRenderFns } from "./notification-component.vue?vue&type=template&id=6157284d&scoped=true&lang=pug"
import script from "./notification-component.js?vue&type=script&lang=js&external"
export * from "./notification-component.js?vue&type=script&lang=js&external"
import style0 from "./notification-component.vue?vue&type=style&index=0&id=6157284d&prod&lang=scss"
import style1 from "./notification-component.vue?vue&type=style&index=1&id=6157284d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157284d",
  null
  
)

export default component.exports